<template>
    <div>
      <!-- 弹窗组件 -->
      <el-dialog
        v-model="dialogVisible"
        title="选择支付方式"
        width="30%"
        :before-close="handleClose"
      >
        <div class="payment-buttons">
          <!-- 微信支付按钮 -->
          <el-button @click="handleWechatPay">
            <img src="../assets/icons/icon-wx.png" alt="微信支付" class="icon" />
            微信支付
          </el-button>
  
          <!-- 支付宝支付按钮 -->
          <el-button @click="handleAlipay">
            <img src="../assets/icons/icon-alipay.png" alt="支付宝支付" class="icon" />
            支付宝支付
          </el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  
  export default {
    setup(props, { expose }) {
      // 控制弹窗显示与隐藏
      const dialogVisible = ref(false);
      // 回调函数
      let callbackFn = null;
  
      // 打开弹窗并设置回调函数
      const openDialog = (callback) => {
        dialogVisible.value = true;
        callbackFn = callback;
      };
  
      // 关闭弹窗
      const handleClose = (done) => {
        dialogVisible.value = false;
        if (callbackFn) {
          callbackFn('cancel'); // 返回 'cancel' 表示用户关闭了弹窗
        }
        done();
      };
  
      // 微信支付逻辑
      const handleWechatPay = () => {
        dialogVisible.value = false;
        if (callbackFn) {
          callbackFn('wechat'); // 返回 'wechat' 表示用户选择了微信支付
        }
      };
  
      // 支付宝支付逻辑
      const handleAlipay = () => {
        dialogVisible.value = false;
        if (callbackFn) {
          callbackFn('alipay'); // 返回 'alipay' 表示用户选择了支付宝支付
        }
      };
  
      // 暴露openDialog方法，以便外部调用
      expose({
        openDialog,
      });
  
      return {
        dialogVisible,
        handleClose,
        handleWechatPay,
        handleAlipay,
      };
    },
  };
  </script>
  
  <style scoped>
  .payment-buttons {
    display: flex;
    justify-content: space-around;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  
  .icon {
    width: 24px;
    height: 24px;
    margin-right: 8px;
  }
  </style>
  